module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Medium-304009385d2d4b4ec46719ea8a8f1b86.woff";